var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9795 7L13.8204 11.7521L9.70378 9.01913L3 13.4688V25H29V12.3243L20.9795 7ZM9.70227 12.3421L12.9567 14.5024V22.2354H5.77675V14.95L9.70227 12.3421ZM15.7335 22.2354V13.804L20.978 10.3229L26.2225 13.804V22.2354H15.7335Z",
    fill: "#A459FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPurple);
export default __webpack_public_path__ + "static/media/logoPurple.2e0690dc5915fa661ff8013b67b16220.svg";
export { ForwardRef as ReactComponent };